/*
 *
 * Attendance constants
 *
 */

// LOAD
export const LOAD_COURSE = 'app/Attendance/LOAD_COURSE';
export const LOAD_COURSE_SUCCESS = 'app/Attendance/LOAD_COURSE_SUCCESS';
export const LOAD_COURSE_ERROR = 'app/Attendance/LOAD_COURSE_ERROR';

export const LOAD_COURSES = 'app/Attendance/LOAD_COURSES';
export const LOAD_COURSES_SUCCESS = 'app/Attendance/LOAD_COURSES_SUCCESS';
export const LOAD_COURSES_ERROR = 'app/Attendance/LOAD_COURSES_ERROR';

// CHANGE/UPDATE
export const UPDATE_COURSE = 'app/Attendance/UPDATE_COURSE';
export const UPDATE_COURSE_SUCCESS = 'app/Attendance/UPDATE_COURSE_SUCCESS';
export const UPDATE_COURSE_ERROR = 'app/Attendance/UPDATE_COURSE_ERROR';

// DELETE
/* export const DELETE_ATTENDANCE = 'app/Attendance/DELETE_ATTENDANCE';
export const DELETE_ATTENDANCE_SUCCESS =
  'app/Attendance/DELETE_ATTENDANCE_SUCCESS';
export const DELETE_ATTENDANCE_ERROR = 'app/Attendance/DELETE_ATTENDANCE_ERROR'; */

export const FLUSH_STATE_ATTENDANCE = 'app/Attendance/FLUSH_STATE_ATTENDANCE';
